import React, { useState, useEffect, useRef, useCallback } from "react";
import CommentModal from "../../Models/CommentBoxModel/CommentBox";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { CompanyTimeline, TimelineLike } from "../../apis/api/TimelineApi";
import { useDispatch, useSelector } from "react-redux";
import LazyLoad from "react-lazy-load";
import Lodderr from "../../components/Lodder/Lodder";
import { motion } from "framer-motion";
import "./Timeline.css";

const Othertimelne = ({ profileData }) => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.TimelineSlice.loading);
  const [commentPost,setcommentPost]= useState();
  const [showCommentModal, setShowCommentModal] = useState(false);

  const userId = profileData?.data?.company_data?.member_id;
  const company_id = profileData?.data?.company_data?.id;

  // const [page, setPage] = useState(0);

  const lastIdRef = useRef(null);

  const [Loading, setLoading] = useState(false);
  const [allLoaded, setAllLoaded] = useState(false);
  const throttleRef = useRef(null);

  const [posts, setPosts] = useState([]);

  const pageRef = useRef(0);
  const fetchingRef = useRef(false);
  
  const fetchPosts = useCallback(async () => {
    if (fetchingRef.current || allLoaded || !company_id) return;
  
    fetchingRef.current = true;
    setLoading(true);
  
    try {
      const response = await dispatch(
        CompanyTimeline({ company_id, page: pageRef.current, userId, last_Id: lastIdRef.current })
      );
  
      if (response?.payload?.status === "success") {
        const { data, lastCompanyPostId } = response.payload;
  
        if (!data.length || lastCompanyPostId === 1) {
          setAllLoaded(true);
          return;
        }
  
        setPosts(prev => [...prev, ...data]);
        lastIdRef.current = lastCompanyPostId;
        pageRef.current += 1; // increment page for next fetch
      } else {
        setAllLoaded(true);
      }
    } catch (err) {
      console.error(err);
    } finally {
      fetchingRef.current = false;
      setLoading(false);
    }
  }, [dispatch, company_id, allLoaded]);
  
  
  

  const startThrottle = () => {
    if (!throttleRef.current) {
      throttleRef.current = setTimeout(() => {
        throttleRef.current = null;
      }, 5 * 60 * 1000);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !Loading && !allLoaded) {
          fetchPosts();
        }
      },
      { threshold: 1.0 }
    );

    const target = document.getElementById("loadMoreTrigger");
    if (target) observer.observe(target);

    return () => observer.disconnect();
  }, [fetchPosts, Loading, allLoaded]);

  useEffect(() => {
    fetchPosts();
  }, [fetchPosts]);

  const handleLike = async (company_post_id, post_like, company_like, liked) => {
    let new_like_count = liked ? post_like - 1 : post_like + 1;
    let new_like_status = liked ? 0 : 1;
  
    // Ensure company_like is a string before splitting
    let likeArr = typeof company_like === "string" ? company_like.split(",").filter(Boolean).map(Number) : [];
  
    if (!liked) {
      // Like: add userId
      likeArr.push(userId);
    } else {
      // Unlike: remove userId
      likeArr = likeArr.filter(id => id !== userId);
    }
  
    const new_company_like = likeArr.join();
  
    try {
      const response = await dispatch(
        TimelineLike({ company_post_id, new_like_count, new_company_like })
      );
  
      if (response.payload.status === "success") {
        setPosts((prevPosts) =>
          prevPosts.map((post) =>
            post.company_post_id === company_post_id
              ? { ...post, post_like: new_like_count, liked: new_like_status, company_like: new_company_like }
              : post
          )
        );
      } else {
        toast.error("Failed to update like status");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong while updating like");
    }
  };
  
  const setcomment =(data)=>{
    setcommentPost(data);
    setShowCommentModal(true);
  }
  return (
    <>
      {loading && <Lodderr />}
      <CommentModal show={showCommentModal}  data ={commentPost} handleClose={() => setShowCommentModal(false)} />
      <motion.div
        className="tl-wrap"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, ease: [0.22, 0.68, 0, 1.2] }}
      >
        {posts.length > 0 ? (
          posts.map((post, index) => (
            <div key={post.company_post_id ?? index} className="tl-post">
              <div className="d-flex justify-content-between align-items-start">
                <div className="d-flex align-items-center ">
                  <img
                    src={
                      post?.member_logo
                        ? post.member_logo
                        : `${process.env.PUBLIC_URL}/gray-avatar-icon-vector-illustration_276184-163.avif`
                    }
                    className="rounded-circle me-2 tl-avatar"
                    alt="User"
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src =
                        `${process.env.PUBLIC_URL}/gray-avatar-icon-vector-illustration_276184-163.avif`;
                    }}
                  />

                  <div>
                    <h6 className="mb-0 tl-name">{post?.member_name}</h6>
                    <p className="mb-0 tl-company">{post?.company_name}</p>
                  </div>
                </div>
              </div>

              {post?.text?.startsWith("blob:") ? (
                post?.text.includes("video") ? (
                  <video src={post?.text} controls className="w-100"></video>
                ) : (
                  <img src={post?.text} alt="Post Preview" className="w-100" />
                )
              ) : post?.text ? (
                <p className="tl-text">{post.text}</p>
              ) : null}

              {post.file_url ? (
                post.file_extension === "image" ? (
                  <LazyLoad>
                    <img src={post.file_url} className="w-100 tl-media" alt="Post Image" />
                  </LazyLoad>
                ) : post.file_extension === "video" ? (
                  <video src={post.file_url} controls className="w-100 tl-media"></video>
                ) : post.file_extension === "audio" ? (
                  <div className="tl-audio">
                    <audio src={post.file_url} controls />
                  </div>
                ) : null
              ) : post.text?.startsWith("blob:") ? (
                post.text.includes("video") ? (
                  <video src={post.text} controls className="w-100 tl-media"></video>
                ) : (
                  <LazyLoad>
                    <img src={post.text} className="w-100 tl-media" alt="Post Image" />
                  </LazyLoad>
                )
              ) : null}

              <div className="tl-foot">
                <button
                  className={`tl-like ${post.liked ? "active" : ""}`}
                  onClick={() =>
                    handleLike(
                      post.company_post_id,
                      Number(post.post_like),
                      post.company_like,
                      post.liked
                    )
                  }
                  type="button"
                >
                  <i className={`bx ${post.liked ? "bxs-heart" : "bx-heart"}`}></i>
                  {post.post_like} Like
                </button>

                <button
                  className="tl-comment"
                  onClick={() => setcomment(post)}
                  type="button"
                >
                  <i className="bx bx-comment"></i>
                  Comment
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="tl-empty">
            <i className="bx bx-message-square-dots"></i>
            <p>No posts yet.</p>
          </div>
        )}
        <div id="loadMoreTrigger"></div>
      </motion.div>
    </>
  );
};

export default Othertimelne;
